// extracted by mini-css-extract-plugin
module.exports = {"link":"_2yWHMYY_gr1A9ZCIJIDWvF","reverse":"_1HKM6jOqP3W4UFDMfy141K"};